<template>
    <div>
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                        class="is-approve save-btn ml-2"
                        type="button"
                        v-if="atendimento.situacao == 0 && isUpdate && permissao.update"
                        @click="promptFinalize"
                        :disabled="isSaving"
                    >
                        {{ $t('finalizar') }}
                </button>
                <button
                    v-if="(permissao.create || permissao.update) && atendimento.situacao == 0"
                    class="save-btn"
                    type="button"
                    @click="saveAtendimento()"
                    :disabled="isSaving"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <div class="page-container geolocalizacao" v-if="isUpdate && cameFrom === 'route'">
            <div class="container-etapa" :key="cor" :style="{ 'background-color': cor }">
                <div class="icon-handle-etapa" :key="icone">
                    <i :class="['fas', icone]"></i>
                </div>
                <div class="etapa">
                    {{ etapaSelected && etapaSelected.nome ? etapaSelected.nome : '---' }}
                </div>
            </div>
            <div class="motivo-atendimento">
                {{
                    motivoAtendimentoSelected && motivoAtendimentoSelected.descricao
                        ? motivoAtendimentoSelected.descricao
                        : '---'
                }}
            </div>
            <div>
                <div class="tempo-container">
                    <span 
                        v-if="permissao.read && !integracao"
                        class="clickable" 
                        @click="openLocationEditorCheckIn"
                    >
                        <b-icon
                            icon="map-marker"
                            class="location-icon"
                            :class="{ disabled: !haveCheckIn }"
                            v-tippy 
                            :title="$t(haveCheckIn ? 'gps-check-in' : 'no-gps-check-in')"
                        />
                    </span>

                    <div class="item">
                        {{
                            check && check.checkindatahora
                                ? $moment(check.checkindatahora).format('L LT')
                                : '---'
                        }}
                    </div>
                </div>
                <div class="tempo-container">
                    <span 
                        v-if="permissao.read && !integracao"
                        class="clickable" 
                        @click="openLocationEditorCheckOut"
                    >
                        <b-icon
                            icon="map-marker"
                            class="location-icon"
                            :class="{ disabled: !haveCheckOut }"
                            v-tippy 
                            :title="$t(haveCheckOut ? 'gps-check-out' : 'no-gps-check-out')"
                        />
                    </span>
                    <div class="item">
                        {{
                            check && check.checkoutdatahora
                                ? $moment(check.checkoutdatahora).format('L LT')
                                : '---'
                        }}
                    </div>
                </div>
                <div class="tempo-container" :key="checks.tempoAtendimento">
                    <div class="label">{{ $t('msg-tempo-atendimento') }}:</div>
                    <div class="tempo-atendimento">
                        {{ check && check.tempoAtendimento ? check.tempoAtendimento : '---' }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-columns-fit">
            <div class="columns">
                <transition name="slide-fade">
                    <div class="column is-4" v-if="isUpdate && compact && cameFrom === 'route'">
                        <div class="page-container cliente">
                            <div class="header-container">
                                <div class="titulo">
                                    <div class="icon-handle">
                                        <i class="fas fa-address-card"></i>
                                    </div>
                                    <label v-text="$t('cliente')" />
                                </div>
                                <!-- button for 'edit' -->
                                <span
                                    v-if="
                                        permissao.update &&
                                        !integracao &&
                                        atendimento.situacao === 0 &&
                                        !isSaving
                                    "
                                    class="clickable"
                                    @click="showModalEditarCliente = !showModalEditarCliente"
                                >
                                    <b-icon 
                                        icon="pencil" 
                                        type="is-primary" 
                                        v-tippy 
                                        :title="$t('editar')"
                                    />
                                </span>
                            </div>
                            <!-- Label for 'codigo' -->
                            <div class="container">
                                <div class="label">{{ $t('codigo') }}:</div>
                                <div class="item">
                                    {{
                                        clientePage && clientePage.codigo
                                            ? clientePage.codigo
                                            : '---'
                                    }}
                                </div>
                            </div>

                            <!-- Label for 'Nome' -->
                            <div class="container">
                                <div class="label">{{ $t('nome') }}:</div>
                                <div class="item">
                                    {{ clientePage && clientePage.nome ? clientePage.nome : '---' }}
                                </div>
                            </div>

                            <!-- Label for 'Razao social' -->
                            <div class="container">
                                <div class="label">{{ $t('rsocial') }}:</div>
                                <div class="item">
                                    {{
                                        clientePage && clientePage.rsocial
                                            ? clientePage.rsocial
                                            : '---'
                                    }}
                                </div>
                            </div>

                            <!-- Label for 'CNPJ' -->
                            <div class="container">
                                <div class="label">{{ $t('sigla-cnpj-cpf') }}:</div>
                                <div class="item">
                                    {{
                                        clientePage && clientePage.cnpj
                                            ? formatCNPJInner(clientePage.cnpj)
                                            : '---'
                                    }}
                                </div>
                            </div>

                            <!-- Label for 'IE' -->
                            <div class="container">
                                <div class="label">{{ $t('sigla-ie-rg') }}:</div>
                                <div class="item">
                                    {{ clientePage && clientePage.ie ? clientePage.ie : '---' }}
                                </div>
                            </div>

                            <!-- Label for 'endereco' -->
                            <div class="container">
                                <div class="label">{{ $t('endereco') }}:</div>
                                <div class="item">
                                    {{
                                        clientePage && clientePage.endereco
                                            ? clientePage.endereco
                                            : '---'
                                    }}
                                </div>
                            </div>

                            <!-- Label for 'numero' -->
                            <div class="container">
                                <div class="label">{{ $t('numero') }}:</div>
                                <div class="item">
                                    {{
                                        clientePage && clientePage.numero
                                            ? clientePage.numero
                                            : '---'
                                    }}
                                </div>
                            </div>

                            <!-- Label for 'bairro' -->
                            <div class="container">
                                <div class="label">{{ $t('bairro') }}:</div>
                                <div class="item">
                                    {{
                                        clientePage && clientePage.bairro
                                            ? clientePage.bairro
                                            : '---'
                                    }}
                                </div>
                            </div>

                            <!-- Label for 'cidade' -->
                            <div class="container">
                                <div class="label">{{ $t('cidade') }}:</div>
                                <div class="item">
                                    {{
                                        clientePage && clientePage.cidade
                                            ? clientePage.cidade
                                            : '---'
                                    }}
                                </div>
                            </div>

                            <!-- Label for 'estado' -->
                            <div class="container">
                                <div class="label">{{ $t('estado') }}:</div>
                                <div class="item">
                                    {{
                                        clientePage && clientePage.estado
                                            ? clientePage.estado
                                            : '---'
                                    }}
                                </div>
                            </div>

                            <!-- Label for 'cep' -->
                            <div class="container">
                                <div class="label">{{ $t('cep') }}:</div>
                                <div class="item">
                                    {{
                                        clientePage && clientePage.cep
                                            ? formatCEPInner(clientePage.cep)
                                            : '---'
                                    }}
                                </div>
                            </div>
                        </div>
                        <div v-if="contatoLength > 0" class="page-container scrollable-div">
                            <div class="header-container">
                                <div class="titulo">
                                    <div class="icon-handle">
                                        <i class="fas fa-user-friends"></i>
                                    </div>
                                    <label v-text="$t('contatos')" />
                                </div>
                            </div>

                            <div v-for="item in contatoPageList" :key="item.id" class="mb-2">
                                <div class="columns separator">
                                    <div class="column">
                                        <!-- Label for 'nome' -->
                                        <div class="container">
                                            <div class="label">{{ $t('nome') }}:</div>
                                            <div class="item">
                                                {{
                                                    item && item.contato && item.contato.nome
                                                        ? item.contato.nome
                                                        : '---'
                                                }}
                                            </div>
                                        </div>

                                        <!-- Label for 'telefone' -->
                                        <div class="container">
                                            <div class="label">{{ $t('telefone') }}:</div>
                                            <div class="item">
                                                {{
                                                    item && item.contato && item.contato.telefone
                                                        ? formatPhoneNumber(item.contato.telefone)
                                                        : '---'
                                                }}
                                            </div>
                                        </div>

                                        <!-- Label for 'data de nascimento' -->
                                        <div class="container">
                                            <div class="label">
                                                {{ $t('data-nascimento') }}:
                                            </div>
                                            <div class="item">
                                                {{
                                                    item &&
                                                    item.contato &&
                                                    item.contato.datanascimento
                                                        ? $moment(
                                                              item.contato.datanascimento
                                                          ).format('L')
                                                        : '---'
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="action-button">
                                        <span
                                            v-if="
                                                permissao.update &&
                                                !integracao &&
                                                atendimento.situacao === 0 &&
                                                !isSaving
                                            "
                                            class="clickable"
                                            @click="
                                                contatoPageSelected = item.contato;
                                                showModalEditarContato = !showModalEditarContato;
                                            "
                                        >
                                            <b-icon 
                                                icon="pencil" 
                                                type="is-primary" 
                                                v-tippy 
                                                :title="$t('editar')"
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <div
                    class="container-dados column"
                    :class="{
                        'is-full': !compact || cameFrom !== 'route',
                        'is-8': compact && cameFrom === 'route',
                    }"
                >
                    <div
                        v-if="isUpdate && cameFrom === 'route'"
                        :key="compact"
                        class="toggle-button"
                        @click="compact = !compact"
                    >
                        <i
                            v-if="maxWidth > 900"
                            :class="
                                compact ? 'fas fa-angle-double-left' : 'fas fa-angle-double-right'
                            "
                        />
                        <i
                            v-else
                            :class="compact ? 'fas fa-angle-double-up' : 'fas fa-angle-double-down'"
                        />
                    </div>
                    <div
                        class="page-container"
                        :class="{
                            'is-new': !compact || cameFrom !== 'route',
                            'is-edit': compact && cameFrom === 'route',
                        }"
                    >
                        <div class="form-columns-fit">
                            <div class="columns is-flex-wrap">
                                <div class="column is-4">
                                    <v-input
                                        :id="generateId(1)"
                                        ref="idatendimentoerpInput"
                                        v-model="atendimento.idAtendimentoErp"
                                        placeholder="placeholder-preencha"
                                        :maxlength="30"
                                        title="codigo"
                                        uppercase
                                        :required="isUpdate"
                                        :invalid="isNull(atendimento.idAtendimentoErp)"
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                                    />
                                </div>
                                <div class="column is-8">
                                    <vss-select
                                        :id="generateId(2)"
                                        ref="motivoAtendimentoSelect"
                                        label="descricao"
                                        :value="motivoAtendimentoSelected"
                                        title="motivo"
                                        :options="motivoAtendimentoList"
                                        :disabled="atendimento.situacao != 0 || isSaving || lengthFormularios > 0"
                                        :loading="motivosAtendimentoLoading"
                                        :invalid="isNull(motivoAtendimentoSelected)"
                                        @search="carregarMotivos"
                                        @input="updateValueMotivoAtendimento"
                                        searchable
                                        required
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div
                                    v-if="checks.dataAtendimento.habilita"
                                    class="column is-half is-full-mobile"
                                >
                                    <verified-date-picker
                                        :id="generateId(3)"
                                        ref="dataAtendimentoInput"
                                        v-model="dataAtendimento"
                                        title="data-atendimento"
                                        inForm
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :years-range="[1, 1]"
                                        :subtractDateDays="30"
                                        :addDateYears="1"
                                        :required="checks.dataAtendimento.obriga"
                                        :invalid="isNull(atendimento.dataAtendimento)"
                                        @input="updateDataAtendimento"
                                    />
                                </div>
                                <div class="column is-half is-full-mobile">
                                    <vss-select
                                        :id="generateId(4)"
                                        ref="funilSelect"
                                        label="descricao"
                                        title="funil"
                                        :value="funilSelected"
                                        :options="funilList"
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :invalid="isNull(funilSelected)"
                                        :loading="funilLoading"
                                        @input="updateValueFunil"
                                        @search="carregarFunis"
                                        clearable
                                        searchable
                                        required
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div class="column is-half is-full-mobile">
                                    <vss-select
                                        :id="generateId(5)"
                                        ref="etapaSelect"
                                        label="nome"
                                        title="etapa"
                                        :value="etapaSelected"
                                        :options="etapaList"
                                        placeholder="msg-selecione-funil"
                                        :disabled="
                                            atendimento.situacao != 0 || isSaving || isNull(funilSelected)
                                        "
                                        :invalid="isNull(etapaSelected)"
                                        :invalidWhenDisabled="true"
                                        :loading="etapasLoading"
                                        @input="updateValueEtapa"
                                        @search="carregarEtapas"
                                        clearable
                                        searchable
                                        required
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div class="column is-half is-full-mobile">
                                    <vss-select
                                        :id="generateId(6)"
                                        ref="empresaSelect"
                                        label="rsocial"
                                        title="empresa"
                                        :value="empresaSelected"
                                        :options="empresaList"
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :invalid="isNull(empresaSelected)"
                                        :loading="empresasLoading"
                                        @input="updateValueEmpresa"
                                        @search="carregarEmpresas"
                                        clearable
                                        searchable
                                        required
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div class="column is-half is-full-mobile">
                                    <vss-select
                                        :id="generateId(7)"
                                        ref="clienteSelect"
                                        label="rsocial"
                                        title="cliente"
                                        :value="clienteSelected"
                                        :options="clienteList"
                                        placeholder="msg-selecione-empresa"
                                        :disabled="
                                            atendimento.situacao != 0 || isSaving || isNull(empresaSelected)
                                        "
                                        :invalid="isNull(clienteSelected)"
                                        :invalidWhenDisabled="true"
                                        :loading="clienteLoading"
                                        @search="carregarClientes"
                                        @input="updateValueCliente"
                                        clearable
                                        searchable
                                        required
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.contato.habilita"
                                >
                                    <div class="field has-addons">
                                        <div class="control is-expanded">
                                            <vss-select
                                                :id="generateId(8)"
                                                ref="contatoSelect"
                                                label="nome"
                                                v-model="contatoSelected"
                                                :title="
                                                    checks.contatoTexto.habilita ?
                                                    $t('motivo-atendimento-contato') :
                                                    $t('contato')
                                                "
                                                :options="contatoList"
                                                placeholder="msg-selecione-cliente"
                                                :disabled="
                                                    atendimento.situacao != 0 ||
                                                    isSaving ||
                                                    isNull(empresaSelected) ||
                                                    isNull(clienteSelected)
                                                "
                                                :loading="contatoLoading"
                                                :required="checks.contato.obriga"
                                                :invalid="verify(contatoSelected, 'contato')"
                                                @search="carregarContatos"
                                                :closeOnSelect="false"
                                                no-clearfix
                                                multiple
                                                clearable
                                                searchable
                                                @onBlurFunction="sendIsChanged()"
                                            />
                                        </div>
                                        <div
                                            v-if="
                                                atendimento.situacao == 0 &&
                                                clienteSelected &&
                                                clienteSelected.id
                                            "
                                            class="control padding-label padding-label-custom"
                                        >
                                            <b-button
                                                @click="
                                                    showModalCadastrarContato = !showModalCadastrarContato
                                                "
                                                icon-right="plus"
                                                v-tippy 
                                                :title="$t('adicionar') + ' ' + $t('contato')"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.propriedade.habilita"
                                >
                                    <vss-select
                                        :id="generateId(9)"
                                        ref="propriedadeSelect"
                                        label="nome"
                                        title="propriedade"
                                        :value="propriedadeSelected"
                                        :options="propriedadeList"
                                        placeholder="msg-selecione-cliente"
                                        :disabled="
                                            atendimento.situacao != 0 ||
                                            isSaving ||
                                            isNull(empresaSelected) ||
                                            isNull(clienteSelected)
                                        "
                                        :invalidWhenDisabled="true"
                                        :loading="propriedadesLoading"
                                        :required="checks.propriedade.obriga"
                                        :invalid="verify(propriedadeSelected, 'propriedade')"
                                        @search="carregarPropriedades"
                                        @input="updateValuePropriedade"
                                        clearable
                                        searchable
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.area.habilita"
                                >
                                    <vss-select
                                        :id="generateId(10)"
                                        ref="areaSelect"
                                        label="descricao"
                                        :value="areaSelected"
                                        title="area"
                                        :options="areaList"
                                        :loading="areasLoading"
                                        placeholder="msg-selecione-propriedade"
                                        :disabled="
                                            isSaving || atendimento.situacao != 0 || isNull(propriedadeSelected)
                                        "
                                        :invalidWhenDisabled="true"
                                        :required="checks.area.obriga"
                                        :invalid="verify(areaSelected, 'area')"
                                        @search="carregarAreas"
                                        @input="updateValueArea"
                                        clearable
                                        searchable
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.talhao.habilita"
                                >
                                    <vss-select
                                        :id="generateId(11)"
                                        ref="talhaoSelect"
                                        v-model="talhaoSelected"
                                        label="descricao"
                                        title="talhao"
                                        :options="talhaoList"
                                        :loading="talhoesLoading"
                                        placeholder="msg-selecione-area"
                                        :disabled="
                                            isSaving || atendimento.situacao != 0 || isNull(areaSelected)
                                        "
                                        :required="checks.talhao.obriga"
                                        :invalidWhenDisabled="true"
                                        :invalid="verify(talhaoSelected, 'talhao')"
                                        @search="carregarTalhoes"
                                        clearable
                                        searchable
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.cultura.habilita"
                                >
                                    <vss-select
                                        :id="generateId(12)"
                                        ref="culturaSelect"
                                        label="descricao"
                                        title="cultura"
                                        :value="culturaSelected"
                                        :options="culturaList"
                                        :loading="culturasLoading"
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :required="checks.cultura.obriga"
                                        :invalid="verify(culturaSelected, 'cultura')"
                                        @search="carregarCulturas"
                                        @input="updateValueCultura"
                                        clearable
                                        searchable
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.cultivar.habilita"
                                >
                                    <vss-select
                                        :id="generateId(13)"
                                        ref="cultivarSelect"
                                        label="descricao"
                                        v-model="cultivarSelected"
                                        title="cultivar"
                                        :options="cultivarList"
                                        :loading="cultivaresLoading"
                                        placeholder="msg-selecione-cultura"
                                        :disabled="
                                            atendimento.situacao != 0 || isSaving || isNull(culturaSelected)
                                        "
                                        :invalidWhenDisabled="true"
                                        :required="checks.cultivar.obriga"
                                        :invalid="verify(cultivarSelected, 'cultivar')"
                                        @search="carregarCultivares"
                                        clearable
                                        searchable
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.faseFenologica.habilita"
                                >
                                    <vss-select
                                        :id="generateId(14)"
                                        ref="faseFenologicaSelect"
                                        label="descricao"
                                        v-model="faseFenologicaSelected"
                                        title="agro-fasefenologica"
                                        :options="faseFenologicaList"
                                        :loading="faseFenologicaLoading"
                                        placeholder="msg-selecione-cultura"
                                        :disabled="
                                            atendimento.situacao != 0 || isSaving || isNull(culturaSelected)
                                        "
                                        :invalidWhenDisabled="true"
                                        :required="checks.faseFenologica.obriga"
                                        :invalid="verify(faseFenologicaSelected, 'faseFenologica')"
                                        @search="carregarFasesFenologicas"
                                        clearable
                                        searchable
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.tipoDeAgroVisita.habilita"
                                >
                                    <vss-select
                                        :id="generateId(15)"
                                        ref="tipoAgroVisitaSelect"
                                        label="descricao"
                                        v-model="tipoAgroVisitaSelected"
                                        title="tipo-agro-visita"
                                        :options="tipoAgroVisitaList"
                                        :loading="tiposDeAgroVisitasLoading"
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :required="checks.tipoDeAgroVisita.obriga"
                                        :invalid="
                                            verify(tipoAgroVisitaSelected, 'tipoDeAgroVisita')
                                        "
                                        @search="carregarTiposAgroVisitas"
                                        clearable
                                        searchable
                                        @onBlurFunction="
                                            sendIsChanged();
                                            carregarAssuntosAgroVisitas('', true);
                                        "
                                    />
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.assuntoDaAgrovisita.habilita"
                                >
                                    <vss-select
                                        :id="generateId(16)"
                                        ref="assuntoAgrovisitaSelect"
                                        label="descricao"
                                        v-model="assuntoAgroVisitaSelected"
                                        title="assunto-agro-visita"
                                        :options="assuntoAgroVisitaList"
                                        :loading="assuntosDaAgrovisitasLoading"
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :required="checks.assuntoDaAgrovisita.obriga"
                                        :invalid="
                                            verify(assuntoAgroVisitaSelected, 'assuntoDaAgrovisita')
                                        "
                                        @search="carregarAssuntosAgroVisitas"
                                        clearable
                                        searchable
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div class="column is-half is-full-mobile">
                                    <v-input
                                        :id="generateId(17)"
                                        title="situacao"
                                        :value="
                                            atendimento.situacao != 0
                                                ? $t('finalizado')
                                                : $t('em-preenchimento')
                                        "
                                        :disabled="alwaysTrue"
                                        readonly
                                    />
                                </div>
                                <div
                                    class="column is-half is-full-mobile"
                                    v-if="checks.safra.habilita"
                                >
                                    <vss-select
                                        :id="generateId(18)"
                                        ref="safraSelect"
                                        label="descricao"
                                        v-model="safraSelected"
                                        title="safra"
                                        :options="safraList"
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :loading="safrasLoading"
                                        :required="checks.safra.obriga"
                                        :invalid="verify(safraSelected, 'safra')"
                                        @search="carregarSafras"
                                        clearable
                                        searchable
                                        @onBlurFunction="sendIsChanged()"
                                    />
                                </div>
                                <div class="column is-full">
                                    <v-textarea
                                        :id="generateId(19)"
                                        v-if="checks.contatoTexto.habilita"
                                        ref="contatoTexto"
                                        v-model.trim="atendimento.contatoTexto"
                                        :title="
                                            checks.contato.habilita ?
                                            $t('motivo-atendimento-contato-texto') :
                                            $t('contato')
                                        "
                                        :maxlength="100"
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :required="checks.contatoTexto.obriga"
                                        :invalid="
                                            checks.contatoTexto.obriga &&
                                            isNull(atendimento.contatoTexto)
                                        "
                                        :rows="1"
                                        disableMLtitle
                                    />
                                </div>
                                <div class="column is-full">
                                    <v-textarea
                                        :id="generateId(20)"
                                        v-if="checks.observacao.habilita"
                                        ref="obsTextArea"
                                        v-model.trim="atendimento.observacao"
                                        :title="$t('observacao')"
                                        :maxlength="100"
                                        :disabled="atendimento.situacao != 0 || isSaving"
                                        :required="checks.observacao.obriga"
                                        :invalid="
                                            checks.observacao.obriga &&
                                            isNull(atendimento.observacao)
                                        "
                                        disableMLtitle
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <lateral-content
            v-model="showModalEditarCliente"
            v-if="clientePage && clientePage.id && clientePage.id > 0"
        >
            <AbaDadosCadastrais
                class="manage-content"
                :idFrom="clientePage.id"
                :isUpdate="true"
                cameFrom="AtendimentoGeral"
                @saved="
                    carregarClienteOnPage();
                    showModalEditarCliente = false;
                "
                @voltar="showModalEditarCliente = false"
                v-if="showModalEditarCliente"
            />
        </lateral-content>
        <lateral-content
            v-model="showModalCadastrarContato"
            v-if="clienteSelected && clienteSelected.id && clienteSelected.id > 0"
        >
            <ContatoModalManage
                :idCliente="clienteSelected.id"
                :integracao="assClienteContatoIntegracao"
                :permissao="permissao"
                :isAtendimento="true"
                @fecharModal="showModalCadastrarContato = false"
                @closeAndReload="
                    showModalCadastrarContato = false;
                    this.carregarContatos();
                "
                v-if="showModalCadastrarContato"
            />
        </lateral-content>
        <lateral-content
            v-model="showModalEditarContato"
            v-if="
                clienteSelected &&
                contatoPageSelected &&
                clienteSelected.id &&
                contatoPageSelected.id &&
                clienteSelected.id > 0 &&
                contatoPageSelected.id > 0
            "
        >
            <ContatoModalManage
                :idContato="contatoPageSelected.id"
                :idCliente="clienteSelected.id"
                :integracao="assClienteContatoIntegracao"
                :permissao="permissao"
                :isAtendimento="true"
                @fecharModal="showModalEditarContato = false"
                @closeAndReload="
                    showModalEditarContato = false;
                    carregarContatoOnPage();
                "
                v-if="showModalEditarContato"
            />
        </lateral-content>
        <MapasGoogleMapsModal
            v-if="permissao.update"
            :center="center"
            :isUpdating="isSaving"
            :locationEditorOpen="locationEditorOpen"
            :update="isUpdate"
            label="selecionar"
            @onCancelLocationEditor="onCancelLocationEditor"
            :showSaveButton="false"
        />
    </div>
</template>

<script>
import EmpresaService from '@/services/vendas/empresa/EmpresaService.js';
import FunilService from '@/services/FunilService.js';
import EtapaService from '@/services/EtapaService';
import AtendimentoService from '@/services/AtendimentoService.js';
import VendasClienteService from '@/services/VendasClienteService.js';
import PropriedadeService from '@/services/agro/PropriedadeService.js';
import MotivoAtendimentoService from '@/services/MotivoAtendimentoService.js';
import AreaService from '@/services/agro/AreaService.js';
import TalhaoService from '@/services/agro/TalhaoService.js';
import AssuntoRtrService from '@/services/agro/AssuntoRtrService.js';
import TipoRtrService from '@/services/agro/TipoRtrService.js';
import CultivarService from '@/services/agro/CultivarService.js';
import CulturaService from '@/services/agro/CulturaService.js';
import UsuarioWebService from '@/services/UsuarioWebService.js';
import FaseFenologicaService from '@/services/agro/FaseFenologicaService.js';
import SafraService from '@/services/agro/SafraService.js';
import ContatoService from '@/services/vendas/cliente/abas/ContatoService.js';
import AssAtendimentoContatoService from '@/services/AssAtendimentoContatoService.js';
import ContatoModalManage from '@/components/vendas/cliente/modal/ContatoModalManage.vue';
import FormFormularioService from "@/services/FormFormularioService";
const AbaDadosCadastrais = () => import('@/components/vendas/cliente/AbaDadosCadastrais.vue');
import AtendimentoValidation from '@/services/validations/AtendimentoValidation';
import allCountries from '@/assets/all-countries';
import MapasGoogleMapsModal from '@/components/shared/maps/MapasGoogleMapsModal';

export default {
    components: {
        ContatoModalManage,
        AbaDadosCadastrais,
        MapasGoogleMapsModal,
    },
    props: {
        uuidFrom: {
            type: String,
            defult: '',
        },
        cameFrom: {
            type: String,
            default: 'route',
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        lengthFotos: {
            type: Number,
            default: 0,
        },
        lengthFormularios: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            /********************************** SERVICES ********************************************/

            assClienteContatoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('CONTATO'),
            integracao: this.$store.state.user.tabelasERPWebServer.includes('CRM_ATENDIMENTO'),
            service: new AtendimentoService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            clienteService: new VendasClienteService(this.$http, this.$router),
            funilService: new FunilService(this.$http, this.$router),
            etapaService: new EtapaService(this.$http, this.$router),
            propriedadeService: new PropriedadeService(this.$http, this.$router),
            motivoService: new MotivoAtendimentoService(this.$http, this.$router),
            areaService: new AreaService(this.$http, this.$router),
            talhaoService: new TalhaoService(this.$http, this.$router),
            assuntoAgroVisitaService: new AssuntoRtrService(this.$http, this.$router),
            tipoAgroVisitaService: new TipoRtrService(this.$http, this.$router),
            cultivarService: new CultivarService(this.$http, this.$router),
            culturaService: new CulturaService(this.$http, this.$router),
            faseFenologicaService: new FaseFenologicaService(this.$http, this.$router),
            safraService: new SafraService(this.$http, this.$router),
            contatoService: new ContatoService(this.$http, this.$router),
            usuarioWebService: new UsuarioWebService(this.$http, this.$router),
            validation: new AtendimentoValidation(this.$root.msgs),
            assAtendimentoContatoService: new AssAtendimentoContatoService(
                this.$http,
                this.$router
            ),
            formFormularioService: new FormFormularioService(this.$http, this.$router),

            /********************************** DADOS ********************************************/

            uuid: this.uuidFrom,
            atendimento: {
                idAtendimentoErp: null,
                motivoAtendimento: null,
                dataAtendimento: this.$moment().format('YYYY-MM-DD'),
                empresa: null,
                cliente: null,
                funil: null,
                etapa: null,
                propriedade: null,
                area: null,
                talhao: null,
                safra: null,
                cultura: null,
                cultivar: null,
                faseFenologica: null,
                tipoAgroVisita: null,
                assuntoAgroVisita: null,
                contato: null,
                contatoTexto: null,
                observacao: null,
                usuario: null,
                situacao: 0,
            },
            motivoAtendimento: {
                qtdMinimoFoto: 0,
                habilitaObrigaContato: null,
                habilitaObrigaContatoTexto: null,
                habilitaObrigaObservacao: null,
                habilitaObrigaPropriedade: null,
                habilitaObrigaArea: null,
                habilitaObrigaTalhao: null,
                habilitaObrigaSafra: null,
                habilitaObrigaCultura: null,
                habilitaObrigaCultivar: null,
                habilitaObrigaFaseFenologica: null,
                habilitaObrigaDataAtendimento: false,
                habilitaObrigaTipoAgroVisita: null,
                habilitaObrigaAssuntoAgroVisita: null,
                // habilitaObrigaFormulario: false,
            },
            checks: {
                contato: { habilita: false, obriga: false },
                contatoTexto: { habilita: false, obriga: false },
                propriedade: { habilita: false, obriga: false },
                area: { habilita: false, obriga: false },
                talhao: { habilita: false, obriga: false },
                safra: { habilita: false, obriga: false },
                cultura: { habilita: false, obriga: false },
                cultivar: { habilita: false, obriga: false },
                faseFenologica: { habilita: false, obriga: false },
                dataAtendimento: { habilita: false, obriga: false },
                tipoDeAgroVisita: { habilita: false, obriga: false },
                assuntoDaAgrovisita: { habilita: false, obriga: false },
                observacao: { habilita: false, obriga: false },
                // formulario: { habilita: false, obriga: false },
            },

            motivoAtendimentoList: [],
            motivoAtendimentoSelected: null,
            motivosAtendimentoLoading: false,

            dataAtendimento: this.$moment().toDate(),

            empresaList: [],
            empresaSelected: null,
            empresasLoading: false,

            clienteList: [],
            clienteSelected: null,
            clienteLoading: false,

            funilList: [],
            funilSelected: null,
            funilLoading: false,

            etapaList: [],
            etapaSelected: null,
            etapasLoading: false,

            propriedadeList: [],
            propriedadeSelected: null,
            propriedadesLoading: false,

            areaList: [],
            areaSelected: null,
            areasLoading: false,

            talhaoList: [],
            talhaoSelected: null,
            talhoesLoading: false,

            safraList: [],
            safraSelected: null,
            safrasLoading: false,

            culturaList: [],
            culturaSelected: null,
            culturasLoading: false,

            cultivarList: [],
            cultivarSelected: null,
            cultivaresLoading: false,

            faseFenologicaList: [],
            faseFenologicaSelected: null,
            faseFenologicaLoading: false,

            tipoAgroVisitaList: [],
            tipoAgroVisitaSelected: null,
            tiposDeAgroVisitasLoading: false,

            assuntoAgroVisitaList: [],
            assuntoAgroVisitaSelected: null,
            assuntosDaAgrovisitasLoading: false,

            contatoList: [],
            contatoSelected: null,
            contatoLoading: false,

            clientePage: null,
            clientePageLoading: false,

            contatoPageList: [],
            contatoPageSelected: null,
            contatoPageLoading: false,

            contatoPageAllList: [],
            contatoPageAllListLoading: false,

            /********************************* CONTROLE ******************************************/

            isSaving: false,

            showModalCadastrarContato: false,
            showModalEditarContato: false,
            showModalEditarCliente: false,

            propertiesToUpdate: {
                propriedade: 'propriedadeSelected',
                area: 'areaSelected',
                talhao: 'talhaoSelected',
                safra: 'safraSelected',
                cultura: 'culturaSelected',
                cultivar: 'cultivarSelected',
                faseFenologica: 'faseFenologicaSelected',
                dataAtendimento: 'dataAtendimento',
                tipoDeAgroVisita: 'tipoAgroVisitaSelected',
                assuntoDaAgrovisita: 'assuntoAgroVisitaSelected',
                observacao: 'observacao',
            },

            usuario: null,
            isGenerating: false,
            alwaysTrue: true,
            dataFocusedOut: true,
            dataInvalid: false,
            compact: false,
            isFinalizar: false,
            permissao: false,
            contexto: this.$route.meta.contexto.slice(0, 3),
            countries: allCountries,
            maxWidth: window.innerWidth,
            contatoLength: 0,
            icone: 'fa-arrows-alt',
            cor: '#D0CFCF',
            check: null,
            haveCheckIn: false,
            haveCheckOut: false,
            locationEditorOpen: false,
            center: { lat: 0, lng: 0 },
            minimoFotos: 0,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            formulariosValidos: false,
            originalIdErp: ''
        };
    },
    created() {
        this.compact = this.isUpdate;

        window.addEventListener('resize', this.updateMaxWidth());

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-atendimento');

        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimento' },
            });
        } else {
            if (this.isUpdate) {
                this.carregarDados();
                this.carregarClienteOnPage();
                this.carregarContatoOnPage();
                this.carregarLengthFotos();
            } else {
                this.getUsuario();
            }
            this.carregarEmpresas();
            this.carregarContatoPageAllList();
        }
    },
    watch: {
        atendimento: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit && this.atendimento.situacao != 2) {
                    this.$emit('isChanged', true);
                }
            },
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateMaxWidth());
    },
    methods: {
        //Prompt de finalização do atendimento
        promptFinalize() {
            this.$root.confirm({
                message: this.$t('msg-finalizar-atendimento'),
                onConfirm: (_) => {
                    this.isFinalizar = true;
                    this.saveAtendimento();
                },
            });
        },
        validateAndFinalizeAtendimento() {
            if (this.minimoFotos > this.lengthFotos) {
                this.$emit('changeTab', 1);
                this.$root.showMessage('alert', 'msg-fotos-atendimento');
            } else {
                this.finalizarAtendimento();
            }
        },
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged() {
            if (!this.isLoadingEdit && this.atendimento.situacao != 2) {
                this.$emit('isChanged', true);
            }
        },
        carregarContatoPageAllList() {
            if (this.uuid != '') {
                this.contatoPageAllListLoading = true;

                this.assAtendimentoContatoService
                    .findAllCombo(this.uuid)
                    .then((value) => {
                        this.contatoPageAllList = value.content;
                    })
                    .catch((e) => {
                        this.contatoPageAllList = [];
                    })
                    .finally((_) => {
                        this.contatoPageAllListLoading = false;
                    });
            }
        },
        updateMaxWidth() {
            this.maxWidth = window.innerWidth;
        },
        generateId(numberId) {
            return this.$route.name + '-geral-' + numberId;
        },
        /* Carregar componentes utilizados */
        carregarDados() {
            this.$store.commit('addLoader');

            this.isLoadingEdit = true;

            this.service
                .find(this.uuid)
                .then((body) => {
                    if (body.content) {
                        this.atendimento = body.content;

                        this.getData();

                        this.mapHabilita();
                        this.mapObriga();

                        this.$emit('checks', this.checks);
                        this.minimoFotos = this.atendimento.motivoAtendimento.qtdMinimaFoto;
                        this.$emit('minimoFotos', this.minimoFotos);

                        this.$emit('idAtendimento', this.atendimento.id);
                        this.$emit('idMotivoAtendimento', this.atendimento.motivoAtendimento.id);

                        this.originalIdErp = this.atendimento.idAtendimentoErp;
                    }

                })
                .catch((e) => {
                    console.error('[ATENDIMENTO] Erro ao carregar atendimento.', e);
                })
                .finally((_) => {
                    this.getUsuario();
                    this.$emit('situacao', this.atendimento.situacao);
                    this.carregarLengthFormularios();
                });
        },
        carregarLengthFotos() {
            this.isLoading = true;

            this.service
                .listAttachments(this.uuid)
                .then((r) => {
                    this.$emit('lengthFotos', r.content.length);
                })
                .catch((e) => {
                    console.error('[ATENDIMENTO] Erro ao carregar atendimento.', e);
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        carregarLengthFormularios() {
            this.isLoading = true;

            this.formFormularioService
                .findAllFormPreenchimento(
                    "datahorainc",
                    "desc",
                    0,
                    50,
                    this.atendimento.motivoAtendimento.id,
                    "crm_motivo_atendimento",
                    this.uuid,
                    "crm_atendimento",
                    ""
                )
                .then((value) => {
                    this.$emit('lengthFormularios', value.content.length);
                })
                .catch((e) => {
                    console.error('[ATENDIMENTO] Erro ao carregar atendimento.', e);
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        carregarClienteOnPage() {
            if (this.uuid != '') {
                this.clientePageLoading = true;

                this.clienteService
                    .findAllByIdUuid(this.uuid)
                    .then((data) => {
                        this.clientePage = {
                            id: data.content.id,
                            codigo: data.content.idclienteerp,
                            nome: data.content.nome,
                            rsocial: data.content.rsocial,
                            cnpj: data.content.cnpjcpf,
                            ie: data.content.ierg,
                            endereco: data.content.endereco,
                            numero: data.content.numero,
                            bairro: data.content.bairro,
                            cidade: data.content.cidade.descricao,
                            estado: data.content.cidade.estado.descricao,
                            cep: data.content.cep,
                        };
                    })
                    .catch((e) => {
                        this.clientePage = [];
                    })
                    .finally((_) => {
                        this.clientePageLoading = false;
                    });
            }
        },
        carregarContatoOnPage(search = '') {
            if (this.uuid != '') {
                this.contatoPageLoading = true;

                this.assAtendimentoContatoService
                    .findAll('datahorainc', 'asc', 1, this.uuid, search)
                    .then((value) => {
                        this.contatoLength = value.totalElements;
                        if (this.contatoLength > 0) {
                            this.contatoPageList = value.content;
                            this.contatoPageList.forEach(contato => {
                                contato.telefone = this.changeDDIPattern(contato.telefone, this.countries);
                            });
                        }
                    })
                    .catch((e) => {
                        this.contatoLength = [];
                    })
                    .finally((_) => {
                        this.contatoPageLoading = false;
                    });
            }
        },
        getData() {
            this.uuid = this.atendimento.uuid;

            this.$emit('uuid', this.uuid);

            this.motivoAtendimentoSelected = this.atendimento.motivoAtendimento;
            this.funilSelected = this.atendimento.funil;
            this.etapaSelected = this.atendimento.etapa;
            this.clienteSelected = this.atendimento.cliente;
            this.empresaSelected = this.atendimento.empresa;
            this.$emit('idEmpresa', this.empresaSelected.id);

            if (this.etapaSelected != null) {
                if (this.etapaSelected.icone) {
                    this.icone = this.mapIcon(this.etapaSelected.icone);
                }
            }

            if (this.etapaSelected) {
                if (this.etapaSelected.cor) {
                    this.cor = this.lightenColor(this.etapaSelected.cor);
                }
            }

            this.dataAtendimento = this.$moment(
                this.atendimento.dataAtendimento,
                'YYYY-MM-DD'
            ).toDate();
            this.propriedadeSelected = this.atendimento.propriedade;
            this.areaSelected = this.atendimento.area;
            this.talhaoSelected = this.atendimento.talhao;
            this.culturaSelected = this.atendimento.cultura;
            this.cultivarSelected = this.atendimento.cultivar;
            this.faseFenologicaSelected = this.atendimento.faseFenologica;
            this.tipoAgroVisitaSelected = this.atendimento.tipoAgroVisita;
            this.assuntoAgroVisitaSelected = this.atendimento.assuntoAgroVisita;
            this.safraSelected = this.atendimento.safra;
            this.check = this.atendimento.checks ? this.atendimento.checks : null;

            if (this.check != null) {
                this.haveCheckIn = this.check.latitudecheckin && this.check.longitudecheckin;
                this.haveCheckOut = this.check.latitudecheckout && this.check.longitudecheckout;
            }
        },
        carregarMotivos(search = '') {
            this.motivosLoading = true;

            this.motivoService
                .findAll('descricao', 'asc', 0, 20, 1, search)
                .then((r) => {
                    this.motivoAtendimentoList = r.content;
                })
                .catch((e) => {
                    this.motivoAtendimentoList = [];
                })
                .finally((_) => {
                    this.motivosLoading = false;
                });
        },

        /*
            @84626
            retornar empresaList que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresaList
        */
        carregarEmpresas(search = '') {
            this.empresasLoading = true;

            this.empresaService
                .findAllCombo(search)
                .then((r) => {
                    this.empresaList = r.content;
                })
                .catch((e) => {
                    this.empresaList = [];
                })
                .finally((_) => {
                    this.empresasLoading = false;
                });
        },
        getUsuario() {
            this.isLoadingEdit = true;
            this.usuarioWebService
                .getByIdUsuarioErp(this.$store.state.user.idusuarioerp)
                .then((r) => {
                    this.atendimento.usuario = r.content;
                })
                .catch((e) => {
                    console.error('[ATENDIMENTO] Erro ao carregar usuário.', e);
                })
                .finally((_) => {
                    setTimeout(() => {
                        this.isLoadingEdit = false;
                        this.$emit('isChanged', false);
                    }, 1000);
                    this.$store.commit('removeLoader');
                });
        },
        carregarClientes(search = '') {
            if (this.empresaSelected && this.empresaSelected.idempresa > 0) {
                this.clienteLoading = true;
                let params = [
                    this.isNull(search) ? '.*' : this.removeToSearch(search),
                    'empresa',
                    this.empresaSelected.idempresa,
                ];

                this.clienteService
                    .findAllCombo(params)
                    .then((body) => {
                        this.clienteList = Object.assign(body.content);
                    })
                    .catch((e) => {
                        this.clienteList = [];
                    })
                    .finally((_) => {
                        this.carregarContatos();
                        this.carregarPropriedades();
                        this.clienteLoading = false;
                    });
            }
        },
        carregarContatos(search = '') {
            if (this.clienteSelected && this.clienteSelected.idcliente > 0) {
                const idCliente = this.clienteSelected.idcliente;

                this.contatoLoading = true;

                this.contatoService
                    .findAllVendas('descricao', 'asc', 0, 20, 3, idCliente, search)
                    .then((value) => {
                        this.contatoList = value.content;
                        this.contatoSelected = this.contatoList.filter((obj2) =>
                            this.contatoPageList.some((obj1) => obj1.contato.uuid === obj2.uuid)
                        );
                    })
                    .catch((e) => {
                        this.contatoList = [];
                    })
                    .finally((_) => {
                        this.contatoLoading = false;
                    });
            }
        },
        carregarFunis(search = '') {
            this.funilLoading = true;

            this.funilService
                .findAllCombo(1, search)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[ATENDIMENTO] Erro status ${r.status} ao carregar funilList.`
                        );
                        console.error(`[ATENDIMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.funilList = r.content;
                    }
                })
                .catch((e) => {
                    console.error('[ATENDIMENTO] Erro ao carregar funilList.', e);
                })
                .finally((_) => {
                    this.carregarEtapas();
                    this.funilLoading = false;
                });
        },
        carregarEtapas(search = '') {
            if (this.funilSelected && this.funilSelected.idFunil > 0) {
                const idFunil = this.funilSelected.idFunil;

                this.etapasLoading = true;

                this.etapaService
                    .findAllCombo(idFunil, 1, search)
                    .then((body) => {
                        this.etapaList = Object.assign(body.content);
                    })
                    .catch((e) => {
                        this.etapasLoading = false;
                        console.error(
                            `[ATENDIMENTO] Erro ao realizar pesquisa da etapa. Termo: [${search}]`,
                            e
                        );
                    })
                    .finally((_) => {
                        this.etapasLoading = false;
                    });
            }
        },
        carregarPropriedades(termo = '') {
            if (this.clienteSelected && this.clienteSelected.idcliente > 0) {
                this.propriedadesLoading = true;

                let params = [
                    // Adicionar filtro complementar
                    this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                    // parâmetro adicional com o nome do que deve ser filtrado
                    this.clienteSelected != null && this.clienteSelected.id ? 'cliente' : null,
                    // parâmetro adicional com o id do que deve ser usado no filtro
                    this.clienteSelected != null && this.clienteSelected.id
                        ? this.clienteSelected.id
                        : null,
                ];

                this.propriedadeService
                    .findAllCombo(params)
                    .then((value) => {
                        if (value.content != null) {
                            this.propriedadeList = value.content;
                        }
                    })
                    .catch((e) => {
                        this.propriedadeList = [];
                    })
                    .finally((_) => {
                        this.carregarAreas();
                        this.propriedadesLoading = false;
                    });
            }
        },
        carregarAreas(termo = '') {
            if (this.propriedadeSelected) {
                this.areasLoading = true;

                let params = [
                    // Adicionar filtro complementar
                    // filtro de busca
                    this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                    // parâmetro adicional com o nome do que deve ser filtrado
                    this.propriedadeSelected != null && this.propriedadeSelected.uuid
                        ? 'propriedade'
                        : null,
                    // parâmetro adicional com o id do que deve ser usado no filtro
                    this.propriedadeSelected != null && this.propriedadeSelected.uuid
                        ? this.propriedadeSelected.uuid
                        : null,
                ];

                this.areaService
                    .findAllCombo(params)
                    .then((r) => {
                        this.areaList = r.content.map((e) => {
                            return {
                                idarea: e.idarea,
                                descricao: e.descricao,
                                id: e.id,
                                uuid: e.uuid,
                            };
                        });
                    })
                    .catch((e) => {
                        this.areaList = [];
                    })
                    .finally((_) => {
                        this.carregarTalhoes();
                        this.areasLoading = false;
                    });
            }
        },
        carregarTalhoes(termo = '') {
            if (this.areaSelected) {
                this.talhoesLoading = true;

                let params = [
                    // Adicionar filtro complementar
                    // filtro de busca
                    this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                    // parâmetro adicional com o nome do que deve ser filtrado
                    this.areaSelected != null && this.areaSelected.uuid ? 'area' : null,
                    // parâmetro adicional com o id do que deve ser usado no filtro
                    this.areaSelected != null && this.areaSelected.uuid
                        ? this.areaSelected.uuid
                        : null,
                ];

                this.talhaoService
                    .findAllCombo(params)
                    .then((r) => {
                        this.talhaoList = r.content.map((e) => {
                            return {
                                idtalhao: e.idtalhao,
                                descricao: e.descricao,
                                id: e.id,
                                uuid: e.uuid,
                            };
                        });
                    })
                    .catch((e) => {
                        this.talhaoList = [];
                    })
                    .finally((_) => {
                        this.talhoesLoading = false;
                    });
            }
        },
        carregarCulturas(search = '') {
            this.culturasLoading = true;

            this.culturaService
                .findAllCombo(search)
                .then((r) => {
                    if (r.content != null) {
                        this.culturaList = r.content.map((e) => {
                            return {
                                idtipocultura: e.idtipocultura,
                                descricao: e.descricao,
                                id: e.id,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error(
                        `[ATENDIMENTO] Erro ao realizar pesquisa da cultura. Termo: [${search}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.culturasLoading = false;
                });
        },
        carregarCultivares(search = '') {
            if (this.culturaSelected != null) {
                const idCultura = this.culturaSelected.id;
                this.cultivaresLoading = true;

                this.cultivarService
                    .findAllComboByIdCultura(1, idCultura, search)
                    .then((r) => {
                        if (r.content != null) {
                            this.cultivarList = r.content.map((e) => {
                                return {
                                    idcultivar: e.idcultivar,
                                    descricao: e.descricao,
                                    id: e.id,
                                };
                            });
                        }
                    })
                    .catch((e) => {
                        console.error(
                            `[ATENDIMENTO] Erro ao realizar pesquisa do cultivo. Termo: [${search}]`,
                            e
                        );
                    })
                    .finally((_) => {
                        this.cultivaresLoading = false;
                    });
            }
        },
        carregarFasesFenologicas(termo = '', clean = false) {
            if (this.culturaSelected != null) {
                this.faseFenologicaLoading = true;

                if (clean) {
                    this.faseFenologicaSelected = null;
                    this.faseFenologicaList = [];
                }

                let params = [
                    // Adicionar filtro complementar
                    this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                    // parâmetro adicional com o nome do que deve ser filtrado
                    this.culturaSelected != null && this.culturaSelected.id ? 'cultura' : null,
                    // parâmetro adicional com o id do que deve ser usado no filtro
                    this.culturaSelected != null && this.culturaSelected.id
                        ? this.culturaSelected.id
                        : null,
                ];

                this.faseFenologicaService
                    .findAllCombo(params)
                    .then((r) => {
                        this.faseFenologicaList = r.content.map((e) => {
                            return {
                                idagrofasefenologica: e.agroFaseFenologica.idagrofasefenologica,
                                descricao: e.agroFaseFenologica.descricao,
                                id: e.agroFaseFenologica.id,
                            };
                        });
                    })
                    .catch((e) => {
                        this.faseFenologicaList = [];
                    })
                    .finally((_) => {
                        this.faseFenologicaLoading = false;
                    });
            }
        },
        carregarTiposAgroVisitas(termo = '') {
            this.tiposDeAgroVisitasLoading = true;

            this.tipoAgroVisitaService
                .findAllCombo(termo)
                .then((r) => {
                    this.tipoAgroVisitaList = r.content.map((e) => {
                        return {
                            idtiportr: e.idtiportr,
                            descricao: e.descricao,
                            id: e.id,
                        };
                    });
                })
                .catch((e) => {
                    this.tipoAgroVisitaList = [];
                })
                .finally((_) => {
                    this.tiposDeAgroVisitasLoading = false;
                });
        },
        carregarAssuntosAgroVisitas(termo = '', clean = false) {
            this.assuntosDaAgrovisitasLoading = true;

            if (clean) {
                this.assuntoAgroVisitaSelected = null;
                this.assuntoAgroVisitaList = [];
            }

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.tipoAgroVisitaSelected != null && this.tipoAgroVisitaSelected.id
                    ? 'motivo'
                    : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.tipoAgroVisitaSelected != null && this.tipoAgroVisitaSelected.id
                    ? this.tipoAgroVisitaSelected.id
                    : null,
            ];

            this.assuntoAgroVisitaService
                .findAllCombo(params)
                .then((r) => {
                    this.assuntoAgroVisitaList = r.content.map((e) => {
                        return {
                            idassuntortr: e.idassuntortr,
                            descricao: e.descricao,
                            id: e.id,
                        };
                    });
                })
                .catch((e) => {
                    this.assuntoAgroVisitaList = [];
                })
                .finally((_) => {
                    this.assuntosDaAgrovisitasLoading = false;
                });
        },
        carregarSafras(search = '') {
            this.safrasLoading = true;

            this.safraService
                .findAllCombo(search)
                .then((value) => {
                    this.safraList = value.content;
                })
                .catch((e) => {
                    this.safraList = [];
                })
                .finally((_) => {
                    this.safrasLoading = false;
                });
        },
        mapHabilita() {
            this.checks.contato.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaContato
            );
            this.checks.contatoTexto.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaContatoTexto
            );
            this.checks.propriedade.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaPropriedade
            );
            this.checks.area.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaArea
            );
            this.checks.talhao.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaTalhao
            );
            this.checks.safra.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaSafra
            );
            this.checks.cultura.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaCultura
            );
            this.checks.cultivar.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaCultivar
            );
            this.checks.faseFenologica.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaFaseFenologica
            );
            this.checks.dataAtendimento.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaDataAtendimento
            );
            this.checks.tipoDeAgroVisita.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaTipoAgroVisita
            );
            this.checks.assuntoDaAgrovisita.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaAssuntoAgroVisita
            );
            this.checks.observacao.habilita = this.mapChecksHabilita(
                this.motivoAtendimentoSelected.habilitaObrigaObservacao
            );
        },
        mapObriga() {
            this.checks.contato.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaContato
            );
            this.checks.contatoTexto.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaContatoTexto
            );
            this.checks.propriedade.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaPropriedade
            );
            this.checks.area.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaArea
            );
            this.checks.talhao.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaTalhao
            );
            this.checks.safra.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaSafra
            );
            this.checks.cultura.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaCultura
            );
            this.checks.cultivar.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaCultivar
            );
            this.checks.faseFenologica.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaFaseFenologica
            );
            this.checks.dataAtendimento.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaDataAtendimento
            );
            this.checks.tipoDeAgroVisita.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaTipoAgroVisita
            );
            this.checks.assuntoDaAgrovisita.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaAssuntoAgroVisita
            );
            this.checks.observacao.obriga = this.mapChecksObriga(
                this.motivoAtendimentoSelected.habilitaObrigaObservacao
            );
        },
        mapChecksObriga(check) {
            return check == 2;
        },
        mapChecksHabilita(check) {
            return check == 1 || check == 2;
        },
        showMessage({ type, message }) {
            this.$root.showMessage(type, message);
        },
        verify(obj, item) {
            let existObjct = false;
            if (!obj && this.checks[item].obriga) {
                existObjct = true;
            }
            return existObjct;
        },
        saveAtendimento() {
            this.updateAtendimentoValues();
            this.setData();

            this.atendimento = this.mapTosave(
                this.atendimento,
                'idAtendimentoErp',
                'motivoAtendimento',
                'dataAtendimento',
                'funil',
                'etapa',
                'empresa',
                'cliente',
                'contato',
                'contatoTexto',
                'propriedade',
                'area',
                'talhao',
                'cultura',
                'cultivar',
                'faseFenologica',
                'tipoAgroVisita',
                'assuntoAgroVisita',
                'situacao',
                'usuario',
                'safra'
            );

            if (
                this.validation.validate(
                    this.atendimento,
                    this.contatoSelected,
                    this.$refs,
                    this.checks,
                    this.isFinalizar,
                    this.isUpdate
                )
            ) {
                if(this.isPrefixSovisInIdErpInvalid(this.atendimento.idAtendimentoErp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
                    
                    return this.$root.showMessage('alert', message, true);
                }

                this.isSaving = true;

                this.service
                    .save(this.atendimento)
                    .then((body) => {
                        if (body.status == 200) {
                            // this.atendimento = body.content;
                            this.uuid = body.content.uuid;

                            if (this.uuid != '') {
                                this.saveAssAtendimentoContato();
                            } else {
                                this.savedAtendimento();
                            }
                        } else if (body.message) {
                            this.isFinalizar = false;
                            if (body.message == 'msg-codigo-duplicado-n') {
                                this.$root.showMessage(
                                    'alert',
                                    this.$t(body.message, { n: this.atendimento.idAtendimentoErp }),
                                    true,
                                    false
                                );
                            } else if (body.message) {
                                this.$root.showMessage('alert', body.message, true);
                            }
                        }
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar atendimento.', e);
                        this.isFinalizar = false;

                        if (this.$te(e.body.message)) {
                            this.$root.showMessage('alert', e.body.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao');
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                        if (this.isFinalizar) this.validateAndFinalizeAtendimento();
                    });
            } else {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                this.isFinalizar = false;
            }
        },
        setData() {
            this.atendimento.motivoAtendimento = this.motivoAtendimentoSelected;
            this.atendimento.funil = this.funilSelected;
            this.atendimento.etapa = this.etapaSelected;
            this.atendimento.empresa = this.empresaSelected;
            this.atendimento.cliente = this.clienteSelected;
            this.atendimento.propriedade = this.propriedadeSelected;
            this.atendimento.area = this.areaSelected;
            this.atendimento.talhao = this.talhaoSelected;
            this.atendimento.cultura = this.culturaSelected;
            this.atendimento.cultivar = this.cultivarSelected;
            this.atendimento.faseFenologica = this.faseFenologicaSelected;
            this.atendimento.tipoAgroVisita = this.tipoAgroVisitaSelected;
            this.atendimento.assuntoAgroVisita = this.assuntoAgroVisitaSelected;
            this.atendimento.safra = this.safraSelected;
        },
        finalizarAtendimento() {
            this.isSaving = true;

            this.service
                .finalize(this.atendimento)
                .then((response) => {
                    if (response.status === 200) {
                        this.$root.showMessage('success', 'msg-sucesso-finalizar-atendimento');
                        this.$emit('situacao', 1);
                        this.recarregar();
                    } else if (response.status === 500) {
                        this.isSaving = false;
                        this.$root.showMessage("alert", "msg-formulario-pendencia");
                        this.$emit('changeTab', 2);
                    }
                })
                .catch((e) => {
                    console.error('Erro ao finalizar atendimento.', e);
                    if (e.status === 500) {
                        this.$root.showMessage('error', e.message || 'Erro interno do servidor. Por favor, tente novamente mais tarde.');
                        this.$emit("formulariosValidos", this.formulariosValidos);
                    } else if (e.message) {
                        this.$root.showMessage('error', e.message);
                    } else {
                        this.$root.showMessage('error', 'msg-erro-finalizar-atendimento');
                    }
                })
                .finally((_) => {
                    this.isSaving = false;
                    this.isFinalizar = false;
                });
        },
        /*
            @87143 - como eh necessario manter os dados durante a troca de
            motivo atendimento na edicao, verifica-se no momento de salvar quais deles
            precisam ser persistidos com base no motivo selecionado
        */
        updateAtendimentoValues() {
            for (const [property, valueToUpdate] of Object.entries(this.propertiesToUpdate)) {
                if (!this.checks[property].habilita) {
                    const nestedProperties = valueToUpdate.split('.');
                    let targetObject = this;
                    for (let i = 0; i < nestedProperties.length - 1; ++i) {
                        targetObject = targetObject[nestedProperties];
                    }
                    if(property == 'observacao') {
                        this.atendimento.observacao = null;
                    } else {
                        targetObject[nestedProperties[nestedProperties.length - 1]] = null;
                    }
                }
            }
        },

        saveAssAtendimentoContato() {
            let matchingObj = [];
            let noMatchingObj = [];

            if (this.contatoLength > 0) {
                matchingObj = this.mapContatoPageList();
                noMatchingObj = this.mapContatoList();
            } else {
                matchingObj = this.mapContatoPageAllList();
                noMatchingObj = this.mapContatoAllList();
            }

            const ass = [...matchingObj, ...noMatchingObj];

            this.assAtendimentoContatoService
                .save(ass)
                .then((body) => {
                    if (body.status == 200) {
                        this.savedAtendimento();
                    } else {
                        if (this.$te(body.message)) {
                            this.$root.showMessage('alert', body.message, true);
                        }
                    }
                })
                .catch((e) => {
                    console.error('Erro ao salvar associação de contato e atendimento.', e);
                    this.$root.showMessage('error', 'msg-problema-realizar-acao');
                });
        },
        // se existir contatos associados ao cliente, veja se eh necessario desativar ou nao a associacao
        mapContatoPageList() {
            return this.contatoPageList.map((obj2) => {
                const matchingObj = this.contatoSelected.find(
                    (obj1) => obj2.contato.id === obj1.id
                );

                return {
                    uuid: obj2.uuid,
                    uuidCrmAtendimento: this.uuid,
                    uuidContato: obj2.contato.uuid,
                    situacao: matchingObj ? 1 : 0,
                };
            });
        },
        // se nao existir contatos associados ao cliente, veja todos os que nao estao associados
        mapContatoList() {
            return this.contatoSelected
                .filter(
                    (item1) => !this.contatoPageList.some((item2) => item2.contato.id === item1.id)
                )
                .map((item) => ({
                    uuidCrmAtendimento: this.uuid,
                    uuidContato: item.uuid,
                    uuid: '',
                    situacao: 1,
                }));
        },
        // se nao existir contatos associados ao cliente, veja se eh necessario desativar ou nao a associacao
        mapContatoPageAllList() {
            return this.contatoPageAllList.map((obj2) => {
                const matchingObj = this.contatoSelected.find(
                    (obj1) => obj2.contato.id !== obj1.id && obj2.uuidCrmAtendimento === this.uuid
                );

                if (matchingObj !== undefined) {
                    return {
                        uuid: obj2.uuid,
                        uuidCrmAtendimento: this.uuid,
                        uuidContato: obj2.contato.uuid,
                        situacao: 1,
                    };
                }
            });
        },
        // se nao existir contatos associados ao cliente, veja todos os que nao estao associados
        mapContatoAllList() {
            return this.contatoSelected
                .filter(
                    (item1) =>
                        !this.contatoPageAllList.some(
                            (item2) =>
                                item2.contato.id === item1.id &&
                                item2.uuidCrmAtendimento === this.uuid
                        )
                )
                .map((item) => ({
                    uuidCrmAtendimento: this.uuid,
                    uuidContato: item.uuid,
                    uuid: '',
                    situacao: 1,
                }));
        },
        /* Metodos que realizam a limpeza dos dados */
        updateValueMotivoAtendimento(motivoAtendimento) {
            this.motivoAtendimentoSelected = motivoAtendimento;

            this.removeFocus();

            if (this.motivoAtendimentoSelected != null) {
                this.$emit('idMotivoAtendimento', this.motivoAtendimentoSelected.id);
                this.mapHabilita();
                this.mapObriga();
            }
        },
        removeFocus() {
            for (const refName in this.$refs) {
                if (this.$refs[refName]) {
                    this.$refs[refName].focusedOut = false;
                }
            }
        },
        updateDataAtendimento(data) {
            this.dataAtendimento = data;

            let m = this.$moment(data, 'L');
            this.atendimento.dataAtendimento = m._isValid ? m.format('YYYY-MM-DD') : '';

            if (this.atendimento.dataAtendimento) {
                this.dataInvalid = !m._isValid;
            } else {
                this.dataInvalid = false;
            }
        },
        updateValueEmpresa(valor) {
            this.empresaSelected = valor;

            this.clienteSelected = null;
            this.propriedadeSelected = null;
            this.areaSelected = null;
            this.talhaoSelected = null;

            this.clienteList = [];
            this.propriedadeList = [];
            this.areaList = [];
            this.talhaoList = [];

            this.carregarClientes();
        },
        updateValueCliente(valor) {
            this.clienteSelected = valor;
            this.contatoSelected = null;
            this.propriedadeSelected = null;
            this.areaSelected = null;
            this.talhaoSelected = null;

            this.contatoList = [];
            this.propriedadeList = [];
            this.areaList = [];
            this.talhaoList = [];

            this.carregarContatos();
            this.carregarPropriedades();
        },
        updateValueFunil(valor) {
            this.funilSelected = valor;

            this.etapaSelected = null;

            this.etapaList = [];

            this.carregarEtapas();
        },
        updateValueEtapa(valor) {
            this.etapaSelected = valor;

            if (valor == null) {
                this.icone = 'fa-arrows-alt';
                this.cor = '#D0CFCF';
            } else {
                this.icone = this.mapIcon(this.etapaSelected.icone);
                this.cor = this.lightenColor(this.etapaSelected.cor);
            }
        },
        updateValuePropriedade(valor) {
            this.propriedadeSelected = valor;

            this.areaSelected = null;
            this.talhaoSelected = null;

            this.areaList = [];
            this.talhaoList = [];

            this.carregarAreas();
        },
        updateValueArea(value) {
            this.areaSelected = value;

            this.talhaoSelected = null;

            this.talhaoList = [];

            this.carregarTalhoes();
        },
        updateValueCultura(value) {
            this.culturaSelected = value;

            this.cultivarSelected = null;
            this.faseFenologicaSelected = null;

            this.cultivarList = [];

            this.carregarCultivares();
            this.carregarFasesFenologicas('', true);
        },
        savedAtendimento() {
            let msg = 'msg-atendimento-salva';

            if (this.atendimento.uuid) {
                msg = 'msg-atendimento-edita';
            }
            if(!this.isFinalizar) this.$root.showMessage('success', msg);
            this.recarregar();
        },
        recarregar() {
            this.carregarDados();
            this.carregarClienteOnPage();
            this.carregarContatoOnPage();
            if(!this.isFinalizar) this.$emit('saved', this.uuid);
        },
        formatCEPInner(value) {
            return this.formatCEP(value);
        },
        formatCNPJInner(value) {
            let cnpjcpf = this.formatCNPJ(value);
            if (cnpjcpf === '') cnpjcpf = this.formatCPF(value);
            return cnpjcpf;
        },
        mapIcon(icone) {
            // Remove 'fas' substring from the 'icon' property
            if (icone.startsWith('FAS ')) {
                icone = icone.slice(4);
                icone = icone.toLowerCase();
            }

            return icone.trim();
        },
        lightenColor(hexColor) {
            const rgbColor = this.hexToRgb(hexColor);
            const hslColor = this.rgbToHsl(rgbColor.r, rgbColor.g, rgbColor.b);

            if (hslColor.l < 50) {
                const checkLightness = hslColor.l + 20;
                if (checkLightness >= 0 && checkLightness <= 100) {
                    hslColor.l = hslColor.l + 20; // Make the color 20% lighter
                }
            } else {
                const checkDarkness = hslColor.l - 20;
                if (checkDarkness >= 0 && checkDarkness <= 100) {
                    hslColor.l = hslColor.l - 20; // Make the color 20% darker
                }
            }

            return `hsl(${hslColor.h}, ${hslColor.s}%, ${hslColor.l}%)`;
        },
        openLocationEditorCheckIn() {
            if (
                !this.onlyNumbers(this.check.latitudecheckin) ||
                !this.onlyNumbers(this.check.longitudecheckin)
            ) {
                this.center.lat = 0;
                this.center.lng = 0;
            } else {
                this.center.lat = +this.check.latitudecheckin;
                this.center.lng = +this.check.longitudecheckin;
            }
            this.locationEditorOpen = true;
        },
        openLocationEditorCheckOut() {
            if (
                !this.onlyNumbers(this.check.latitudecheckout) ||
                !this.onlyNumbers(this.check.longitudecheckout)
            ) {
                this.center.lat = 0;
                this.center.lng = 0;
            } else {
                this.center.lat = +this.check.latitudecheckout;
                this.center.lng = +this.check.longitudecheckout;
            }
            this.locationEditorOpen = true;
        },
        onCancelLocationEditor() {
            this.locationEditorOpen = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.loading {
    opacity: 0.5;
    pointer-events: none;
}
.geolocalizacao {
    display: flex;
    margin-bottom: 20px;

    .motivo-atendimento {
        color: $sovis-black;
        font-style: normal;
        font-weight: 1000;
        line-height: normal;
        font-size: 18px;
        flex: 1;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }
    .tempo-container {
        display: flex;
        align-items: center;
        margin-bottom: 2px;
    }
    .item {
        font-size: 12px;
        padding-bottom: 5px;
        padding-left: 10px;
    }
    .container-etapa {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        min-width: 250px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    }
    .icon-handle-etapa {
        color: #fff;
        margin-right: 10px;

        svg {
            width: 40px;
            height: 32px;
        }
    }
    .etapa {
        font-style: normal;
        font-weight: 1000;
        line-height: normal;
        font-size: 17px;
        color: #fff;
    }
    .geo-button {
        background: transparent;
        padding-right: 10px button {
            font-size: 1.5rem;
            background: transparent;
            padding: 20px !important;
            border: none;
        }
    }
    .tempo-atendimento {
        font-size: 12px;
        padding-bottom: 5px;
    }
}
.scrollable-div {
    max-height: 500px;
    overflow-y: auto;
}
.titulo {
    display: flex;
    align-items: center;
    flex: 1;
    .icon-handle {
        color: $primary-color;
        padding: 5px 10px 0 0;

        svg {
            width: 25px;
            height: 25px;
        }
    }
}

.cliente {
    margin-bottom: 10px;
}
.container {
    display: flex;
    align-items: center;
}
.header-container {
    display: flex;
    align-items: center;
    padding-bottom: 15px;
}

label {
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 17px;
    color: $primary-color;
}
.item {
    font-size: 12px;
    padding-bottom: 5px;
}
.toggle-button {
    padding: 5px;
    cursor: pointer;
    background-color: #fafafa;
    color: $primary-color;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.toggle-button:hover {
    background-color: #f8f8f8;
}
.container-dados {
    display: flex;
    flex: 1;
}
.is-edit {
    width: 97%;
}
.is-new {
    width: 100%;
}
.separator {
    border: 1px solid $primary-color;
    border-radius: 10px;
    margin: 0;
    padding: 0;
    margin-bottom: 25px;
}
.label {
    color: $sovis-black;
    padding: 0 10px 0 5px;
    font-size: 12px;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.5s;
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(-50px);
    opacity: 0;
}
.manage-content {
    padding: 20px 40px;
    margin-left: 25px;
}
.action-button {
    background: transparent;
    padding: 10px;
    button {
        font-size: 1.5rem;
        background: transparent;
        color: $primary-color;
        padding: 20px !important;
        border: none;
    }
}

.location-icon:hover {
    color: $primary-color-hover;
    cursor: pointer;
}
.location-icon {
    color: $primary-color;
    &.disabled {
        opacity: 0.3;
    }
}
@media screen and (max-width: 900px) {
    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateY(-50px);
    }
    .toggle-button {
        width: 320px !important;
    }
}
</style>
